<template>
  <div>
    <div
      style="width: 80%;margin-left: 10%;text-align: center;margin-top: 15px;line-height: 30px;"
    >
      <div v-if="isAgent || isBrand || isOperator">
        <span style="font-size: 24px;">常用功能</span>
      </div>
      <div v-else>
        <div>请等待厂家审核，或联系管理员进行费用充值及功能开通</div>
        <img
          height="500"
          width="780"
          src="../../assets/images/未授权账号.png"
        />
      </div>
      <div v-if="isBrand">
        <el-row :gutter="12">
          <el-col :span="8">
            <div class="fullItemClass" @click="routePathTo(1)">
              <div>
                <img
                  src="../../assets/images/quickRoute1.png"
                  style="height: 70px;"
                />
                <div><span>开单批准</span></div>
              </div>
            </div>
            <div class="fullItemClass" @click="routePathTo(2)">
              <div>
                <img
                  src="../../assets/images/quickRoute2.png"
                  style="height: 70px;"
                />
                <div><span>退单批准</span></div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="fullItemClass" @click="routePathTo(3)">
              <div>
                <img
                  src="../../assets/images/quickRoute3.png"
                  style="height: 70px;"
                />
                <div><span>代理商充值</span></div>
              </div>
            </div>
            <div class="fullItemClass" @click="routePathTo(4)">
              <div>
                <img
                  src="../../assets/images/quickRoute4.png"
                  style="height: 70px;"
                />
                <div><span>代理商管理</span></div>
              </div>
            </div>
            <div class="fullItemClass" @click="routePathTo(5)">
              <div>
                <img
                  src="../../assets/images/quickRoute5.png"
                  style="height: 70px;"
                />
                <div><span>代理商类型管理</span></div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="fullItemClass" @click="routePathTo(6)">
              <div>
                <img
                  src="../../assets/images/quickRoute6.png"
                  style="height: 70px;"
                />
                <div><span>租赁产品管理</span></div>
              </div>
            </div>
            <div class="fullItemClass" @click="routePathTo(7)">
              <div>
                <img
                  src="../../assets/images/quickRoute7.png"
                  style="height: 70px;"
                />
                <div><span>租赁价格管理</span></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="isAgent || isOperator">
        <el-row type="flex" justify="center">
          <el-col :span="8">
            <div class="fullItemClass" @click="routePathTo(8)">
              <div>
                <img
                  src="../../assets/images/quickRoute1.png"
                  style="height: 70px;"
                />
                <div><span>开单申请</span></div>
              </div>
            </div>
            <div class="fullItemClass" @click="routePathTo(9)">
              <div>
                <img
                  src="../../assets/images/quickRoute2.png"
                  style="height: 70px;"
                />
                <div><span>退单申请</span></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'shortCuts',
  components: {},
  data() {
    return {
      isBrand: false,
      isAgent: false,
      isOperator: false
    }
  },
  mounted() {
    var thiz = this
    axios
      .get(this.$store.getters.getApiValue + '/srsUser/getMyData.do')
      .then(function(response) {
        var data = response.data
        if (data.status == '200') {
          if (data.data.role == '4') {
            thiz.isBrand = true
          }
          if (
            data.data.role == '2' ||
            data.data.role == '3' ||
            data.data.role == '8'
          ) {
            thiz.isAgent = true
          }
          if (data.data.role == '9') {
            thiz.isOperator = true
          }
        } else {
          thiz.$message.error(data.message)
        }
      })
      .catch(function(error) {
        thiz.$message.error('系统异常，请与管理员联系!')
        console.log(error)
      })
  },
  methods: {
    routePathTo(val) {
      if (val == '1') {
        this.$router.push({ path: '/accountManager/accountRecord' })
      } else if (val == '2') {
        this.$router.push({ path: '/accountManager/returnRecord' })
      } else if (val == '3') {
        this.$router.push({ path: '/agentManagement/agentRecharge' })
      } else if (val == '4') {
        this.$router.push({ path: '/agentManagement/agentType' })
      } else if (val == '5') {
        this.$router.push({ path: '/agentManagement/agentTypeSet' })
      } else if (val == '6') {
        this.$router.push({ path: '/deviceManagement/deviceType' })
      } else if (val == '7') {
        this.$router.push({ path: '/productCenter/productSet' })
      } else if (val == '8') {
        this.$router.push({ path: '/accountManager/accountRecord' })
      } else if (val == '9') {
        this.$router.push({ path: '/accountManager/returnRecord' })
      }
    }
  }
}
</script>

<style>
</style>
